module.exports = __webpack_public_path__ + "static/media/img_pr.0bca3843.svg";